import React from 'react';

export default function ButtonIcon({ icon, alt }) {
  if (!icon) {
    return null;
  }
  return (
    <img
      src={icon}
      alt={alt || ''}
      className="mr-2 inline-block h-4 w-4 flex-none object-contain align-middle"
    />
  );
}
